<template>
  <div>
    <el-dialog
      :title="dialogFormTitle"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
      :center="true"
      top="20vh"
      :close-on-click-modal="false"
      :before-close="() => closeReimbursementCategoryDialog()"
      v-loading.fullscreen.lock="login_loading"
    >
      <div>
        <el-form
          :model="ReimbursementCategory"
          :rules="rules"
          ref="ReimbursementCategoryEditForm"
          label-width="100px"
          size="small"
        >
        <!-- 添加按钮的弹框1 -->
          <div v-if="show_type">
            <el-form-item label="报销类目" prop="name">
              <el-input v-model="ReimbursementCategory.name" clearable></el-input>
            </el-form-item>
          </div>
          <!-- 添加成功后详情弹框0 -->
          <div v-else>
            <el-descriptions
              class="margin-top"
              :column="1"
              :labelStyle="{ width: '120px', 'text-align': 'center' }"
              :contentStyle="{ 'text-align': 'center' }"
              border
            >
              <el-descriptions-item>
                <template slot="label">
                  <span>报销类目</span>
                </template>
                <span>{{ReimbursementCategory.name}}</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-form>
      </div>
      <!-- 底部按钮展示 -->
      <div slot="footer" class="dialog-footer">
        <!-- 详情底部按钮0 -->
        <div v-if="show_type === 0">
          <el-button
            v-if="$_has(edit_auth)"
            type="primary"
            plain
            @click="$emit('show_edit')"
            >修改</el-button
          >
          <el-button
            v-if="$_has(del_auth)"
            type="danger"
            plain
            @click="ReimbursementCategoryDel('ReimbursementCategoryEditForm')"
            >删除</el-button
          >
          <el-button plain @click="closeReimbursementCategoryDialog()"
            >关闭</el-button
          >
        </div>
        <!-- 添加底部按钮1 -->
        <div v-else-if="show_type === 1">
          <el-button
            type="success"
            plain
            @click="submitInsert('ReimbursementCategoryEditForm')"
            >确定</el-button
          >
          <el-button type="warning" plain @click="resetForm()">重置</el-button>
          <el-button plain @click="closeReimbursementCategoryDialog()"
            >关闭</el-button
          >
        </div>
        <!-- 修改底部按钮2 -->
        <div v-else>
          <el-button
            type="success"
            plain
            @click="submitEdit('ReimbursementCategoryEditForm')"
            >确定修改</el-button
          >
          <el-button plain @click="closeReimbursementCategoryDialog()"
            >取消操作</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  reimbursement_category_add_request,
  reimbursement_category_del_request,
  reimbursement_category_edit_request,
} from "@/network/finance/ReimbursementCategory.js";

export default {
  name: "ReimbursementCategoryEditComponent",
  data() {
    return {
      login_loading:false,
      ReimbursementCategory: {
        name: "",
        id: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "报销类目必填",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    dialogFormTitle() {
      if (this.show_type === 0) {
        return "报销类目详情";
      } else if (this.show_type === 1) {
        return "添加报销类目";
      } else {
        return "修改报销类目";
      }
    },
  },
  methods: {
    closeReimbursementCategoryDialog() {
      this.resetForm();
      this.$emit("exitReimbursementCategoryDialog");
    },
    submitInsert(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        this.ReimbursementCategoryInsert(formName);
      });
    },
    ReimbursementCategoryInsert(formName) {
      this.login_loading = true;
      reimbursement_category_add_request(this.ReimbursementCategory)
        .then((s) => {
          this.login_loading = false;
          if (s.status === 0) {
            this.$message.success("添加成功!");
            this.$emit("exitReimbursementCategoryDialog");
            this.$emit("search");
            this.$emit("details_row", s.result.id * 1);
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.login_loading = false;
          this.$message.error(err);
        });
    },
    resetForm() {
      this.ReimbursementCategory = {
        name: "",
      };
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        this.ReimbursementCategoryEdit(formName);
      });
    },
    ReimbursementCategoryEdit(formName) {
      this.login_loading = true;
      this.ReimbursementCategory.id = this.id;
      reimbursement_category_edit_request(this.ReimbursementCategory)
        .then((s) => {
          this.login_loading = false;
          if (s.status === 0) {
            this.$message.success("修改成功!");
            this.$emit("exitReimbursementCategoryDialog");
            this.$emit("search");
            this.$emit("details_row", this.ReimbursementCategory.id);
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.login_loading = false;
          this.$message.error(err);
        });
    },
    ReimbursementCategoryDel(formName) {
      this.$confirm(
        "是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          reimbursement_category_del_request(this.id)
            .then((s) => {
              if (s.status === 0) {
                this.$message.success("删除成功!");
                this.$emit("search");
              } else {
                this.$message.error(s.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => this.closeReimbursementCategoryDialog());
        })
        .catch((err) => {});
    },
  },
  filters: {},
  props: {
    dialogFormVisible: Boolean,
    id: {
      type: Number,
      default() {
        return 0;
      },
    },

    reimbursement_category_details_data: {
      type: Object,
      default() {
        return {};
      },
    },
    show_type: {
      type: Number,
      default() {
        return 0;
      },
    },
    edit_auth: String,
    del_auth: String,
  },
  created() {},
  destoryed() {},
  mounted() {},
  updated() {},
  components: {},
  watch: {
    reimbursement_category_details_data(newVal) {
      this.ReimbursementCategory = newVal;
    },
  },
};
</script>

<style lang="less"></style>
